import React from 'react';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { CheckboxBase, CommandMenu, TagEditable } from '@milanote/roma';
import { GridListItem } from 'react-aria-components';
import LabelListElementActions from './LabelListElementActions';
import { useDispatch } from 'react-redux';
import { updateLabel } from '../../../../../../../common/labels/labelActions';

type Props = {
    label: Label;
    onEditingChange: (labelId: string, nextIsEditing: boolean) => void;
    isSelected?: boolean;
    isEditing: boolean;
};

const LabelListElement: React.FC<Props> = ({ label, onEditingChange, isSelected = false, isEditing = false }) => {
    const dispatch = useDispatch();
    const { _id, name, color } = label;

    function handleEditingChange(nextIsEditing: boolean) {
        onEditingChange(_id, nextIsEditing);
    }

    const handleCommitRename = (nextName: string) => {
        dispatch(updateLabel(label._id, { name: nextName }));
    };

    return (
        <GridListItem id={_id} textValue={name} className="w-full py-0.5 outline-hidden">
            {(state) => (
                <CommandMenu.Base.Item
                    isSelected={isSelected}
                    isDisabled={state.isDisabled}
                    isFocused={state.isFocused}
                    isFocusVisible={state.isFocusVisible}
                    isHovered={state.isHovered}
                    className="mx-0.5 px-3"
                    size="sm"
                >
                    <div className="flex min-w-0 w-full items-center gap-2">
                        <div className="p-0.5">
                            <CheckboxBase
                                size="sm"
                                variant="form"
                                isSelected={isSelected}
                                isDisabled={state.isDisabled}
                            />
                        </div>

                        <div className="min-w-0 -my-1">
                            <TagEditable
                                value={name}
                                color={color}
                                size="md"
                                isEditing={isEditing}
                                onEditingChange={handleEditingChange}
                                onCommit={handleCommitRename}
                                className="inline-flex w-auto max-w-full"
                            />
                        </div>

                        <LabelListElementActions
                            label={label}
                            isHovered={state.isHovered}
                            onRename={() => handleEditingChange(true)}
                        />
                    </div>
                </CommandMenu.Base.Item>
            )}
        </GridListItem>
    );
};

export default LabelListElement;
